import React from "react";
import "./App.css";
import Homepage from "./containers/homepage";

function App() {
  return (
    <div className="App">
      <Homepage />
    </div>
  );
}

export default App;
